import React from 'react';
import { getIconSVG } from '../../utils/icons';
import { SECTIONS } from '../../config/constants';
import AvatarDisplay from '../AvatarDisplay';

/**
 * Sidebar navigation component
 */
function Sidebar({ activeSection, onSectionChange, sidebarVisible, currentUser }) {
    const navItems = [
        { key: SECTIONS.MAP, icon: 'map', label: 'Map' },
        { key: SECTIONS.MISSIONS, icon: 'missions', label: 'Missions' },
        { key: SECTIONS.DELIVERIES, icon: 'package', label: 'Deliveries' },
        { key: SECTIONS.DRONES, icon: 'drones', label: 'Drones' },
        { key: SECTIONS.LOGS, icon: 'logs', label: 'Logs' },
    ];

    const isAdmin = currentUser?.role === 'admin';

    const footerItems = [
        { key: SECTIONS.PROFILE, icon: 'user', label: 'Profile' },
        ...(isAdmin ? [{ key: SECTIONS.ADMIN, icon: 'admin', label: 'Admin' }] : []),
        { key: SECTIONS.SETTINGS, icon: 'settings', label: 'Settings' },
    ];

    return (
        <div className={`sidebar-nav ${sidebarVisible ? 'expanded' : 'collapsed'}`}>
            <div className="sidebar-header">
                <img
                    src={`${process.env.PUBLIC_URL}/BERAMLOGO.png`}
                    alt="BERAM UTM Logo"
                    className="sidebar-logo"
                />
                {sidebarVisible && (
                    <div style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                        <h1 className="sidebar-title">BERAM UTMS</h1>
                        <span style={{ fontSize: 10, fontWeight: 600, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--textMuted)', fontFamily: 'var(--font-label)', whiteSpace: 'nowrap' }}>Fleet Command</span>
                    </div>
                )}
            </div>

            <nav className="sidebar-menu">
                {navItems.map(item => (
                    <button
                        key={item.key}
                        className={`nav-item ${activeSection === item.key ? 'active' : ''}`}
                        onClick={() => onSectionChange(item.key)}
                        title={item.label}
                    >
                        <span
                            className="nav-icon"
                            dangerouslySetInnerHTML={{ __html: getIconSVG(item.icon, 24, 'currentColor') }}
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        />
                        {sidebarVisible && <span className="nav-label">{item.label}</span>}
                    </button>
                ))}
            </nav>

            <div className="sidebar-footer">
                {footerItems.map(item => (
                    <button
                        key={item.key}
                        className={`nav-item ${activeSection === item.key ? 'active' : ''}`}
                        onClick={() => onSectionChange(item.key)}
                        title={item.label}
                    >
                        {item.key === SECTIONS.PROFILE ? (
                            <span className="nav-icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <AvatarDisplay avatarId={currentUser?.avatar} name={currentUser?.name} size={28} profilePhoto={currentUser?.profilePhoto} />
                            </span>
                        ) : item.key === SECTIONS.ADMIN ? (
                            <span className="nav-icon" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                                    <path d="M9 12l2 2 4-4"></path>
                                </svg>
                            </span>
                        ) : (
                            <span
                                className="nav-icon"
                                dangerouslySetInnerHTML={{ __html: getIconSVG(item.icon, 24, 'currentColor') }}
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                            />
                        )}
                        {sidebarVisible && <span className="nav-label">{item.label}</span>}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default Sidebar;
